import React, { useEffect, useState } from 'react';
import { Image, Page, pdf, PDFDownloadLink, PDFViewer, StyleSheet, Text, View } from '@react-pdf/renderer';
import PdfGenerator from '../../components/Dossier/PdfGenerator';
import useAuthz from '../../hooks/useAuthz';
import { useNavigate } from 'react-router';
import axios from 'axios';
import { URL_API } from '../../utils/globalConfig';
import MyButton from '../../components/Layout/MyButton';
import { faArrowLeft, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { faSave } from '@fortawesome/free-regular-svg-icons';
import TopBar from '../../components/Layout/TopBar';
import logoSanef from '../../images/logo.png';
import { useAlert } from 'react-alert';
import moment from 'moment';
import { FACTURATION_TYPE, IDENTITY_AGENT_TYPE, REQUEST_PASS_TYPE } from '../../constants/enum';
import htmlToDraft from 'html-to-draftjs';

const styles = StyleSheet.create({
    page: {
        flexDirection: 'column',
        fontSize: '12px',
        height: 'auto',
        paddingBottom: '45px',
    },
    row: {
        flexDirection: 'row',
    },
    caracRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        lineHeight: '1.2',
        minHeight: '10px',
    },
    sectionHead: {
        margin: 10,
        padding: 10,
        flexGrow: 1,
        height: '15%',
        maxHeight: '15%',
    },
    sectionBody: {
        margin: '10px 0',
        padding: 0,
        flexGrow: 1,
        height: 'auto',
        marginBottom: '-10px',
    },
    sectionFoot: {
        margin: 10,
        padding: 10,
        flexGrow: 1,
        maxHeight: '80px',
    },
    pdfBody: {
        fontFamily: 'Courier',
        fontSize: '11px',
    },
    bold: {
        fontWeight: 'bold',
    },
    underline: {
        textDecoration: 'underline',
    },
    italic: {
        fontStyle: 'italic',
    },
});

// TODO: stocker les informations dans le local storage et les supprimées quand on sauvegarde
const AgreementsViewer = (props) => {
    const requestPassId = new URLSearchParams(location.search).get('id') || 0;
    const navigate = useNavigate();
    const alert = useAlert();
    const currentDate = moment();
    const [authz, user, profil] = useAuthz();
    const [demandePassage, setDemandePassage] = useState(null);
    const [devis, setDevis] = useState(null);
    const [saveAgreements, setSaveAgreements] = useState({
        id: requestPassId,
        data: null,
        fileName: 'Accords de principe demande n° [' + requestPassId + ']',
        mimeType: 'application/pdf',
        isInit: true,
    });
    const [counties, setCounties] = useState([]);
    const [signature, setSignature] = useState(null);
    const [fileName, setFileName] = useState('');
    const [legalNotice, setLegalNotice] = useState('');
    const [particularNotice, setParticularNotice] = useState('');
    const [pdfBlob, setPdfBlob] = useState(null);

    //#region useEffect

    useEffect(async () => {
        if (profil.profil === 1 || profil.profil === 2) {
            // Chargement de la demande de passage
            await Promise.all([
                apiGetDevis(),
                apiGetSignature(),
                await apiGetLegalNotice(),
                await apiGetParticularNotice(),
            ]).then(() => apiGetRequestPass());
        } else {
            alert.error('Vous n\'êtes pas autorisé à accéder à la création d\'un dossier');
            navigate('/');
        }
    }, []);
    useEffect(() => {
        if (demandePassage) {
            let nbPassages = {
                nbPass: Number(demandePassage.metadata.datePassage.nbPassageAller) + Number(demandePassage.metadata.datePassage.nbPassageRetour),
                nbFare: demandePassage.metadata.datePassage.nbPassageAller,
                nbReturn: demandePassage.metadata.datePassage.nbPassageRetour,
            };
            let nbTransExcept = demandePassage.metadata.caracConvoi.nbTransExcept;
            let category = setCategory();
            let startDate = demandePassage.metadata.complInfo.startDate;
            let endDate = demandePassage.metadata.complInfo.endDate;
            let duration = demandePassage.metadata.datePassage.duration;
            let liaison = formatPinPoints();
            let route = formatItineraire();
            let natureCharge = demandePassage.metadata.caracConvoi.natureCharge;
            let longueurCharge = (Number(demandePassage.metadata.caracConvoi.longueurCharge) / 1000).toFixed(2);
            let largeurCharge = (Number(demandePassage.metadata.caracConvoi.largeurCharge) / 1000).toFixed(2);
            let hauteurCharge = (Number(demandePassage.metadata.caracConvoi.hauteurCharge) / 1000).toFixed(2);
            let chargeMax = 0;

            if (demandePassage.metadata.caracConvoi.configurations.length > 0) {
                demandePassage.metadata.caracConvoi.configurations.map((config) => {
                    if (Number(config.chargeMaxiEssieu) > chargeMax)
                        chargeMax = Number(config.chargeMaxiEssieu);
                });
            } else {
                chargeMax = '<13 T.';
            }

            let counties = [];

            // TODO: Manque d'info
            demandePassage.metadata.reference.departments.map((countyName) => {
                counties.push({
                    county: countyName,
                    receptionDate: demandePassage.metadata.tracingDossier.receptionDate,
                    nbPassages: nbPassages,
                    nbTransExcept: nbTransExcept,
                    category: category,
                    startDate: startDate,
                    endDate: endDate,
                    duration: duration,
                    liaison: liaison,
                    route: route,
                    natureCharge: natureCharge,
                    maxWeight: demandePassage.metadata.caracConvoi.masseTotaleCharge,
                    longueurCharge: longueurCharge,
                    largeurCharge: largeurCharge,
                    hauteurCharge: hauteurCharge,
                    chargeMax: chargeMax,
                });
            });

            setCounties(counties);
        }
    }, [demandePassage]);

    //#endregion

    // region API
    const apiGetRequestPass = () => {
        if (requestPassId > 0) {
            axios({
                method: 'GET',
                url: `${URL_API}/demande-passage/recuperer-demande`,
                params: {
                    'id': requestPassId,
                },
            })
            .then((response) => {
                alert.removeAll();
                let requestPassData = response.data;
                if (requestPassData) {
                    setDemandePassage(requestPassData);
                    let departmentNumbers = requestPassData.metadata.reference.departments.map(department => {
                        const match = department.match(/\((\d+)\)/);
                        return match ? match[1] : null;
                    }).filter(Boolean);
                    setFileName(`[ACCORDS-PRINCIPE]_[${requestPassId}-${requestPassData.metadata.reference.numDossier}-${departmentNumbers.join('-')}]_[${moment().format('DD-MM-YYYY')}]`);
                }
            })
            .catch((error) => {
                alert.removeAll();
                alert.error(error.message);
            });
        }
    };

    const apiGetDevis = () => {
        if (requestPassId > 0) {
            axios({
                method: 'GET',
                url: `${URL_API}/facturation/get-fact-by-dossier-and-type`,
                params: {
                    'dossier_id': requestPassId,
                    'type': FACTURATION_TYPE.DEVIS,
                },
            })
            .then((response) => {
                alert.removeAll();

                if (response.data.length > 0)
                    setDevis(response.data[0]);

            })
            .catch((error) => {
                alert.removeAll();
                alert.error(error.message);
            });
        }
    };

    const apiGetLegalNotice = async () => {
        axios({ method: 'get', url: URL_API + '/parameters/get-by-key', params: { key: 'LEGAL_NOTICE' } })
        .then((response) => {
            alert.removeAll();
            setLegalNotice(response.data);
        })
        .catch((error) => {
            alert.removeAll();
            alert.error(error.message);
        });
    };

    const apiGetParticularNotice = async () => {
        axios({ method: 'get', url: URL_API + '/parameters/get-by-key', params: { key: 'PARTICULAR_NOTICE' } })
        .then((response) => {
            alert.removeAll();
            setParticularNotice(response.data);
        })
        .catch((error) => {
            alert.removeAll();
            alert.error(error.message);
        });
    };

    const apiGetSignature = () => {
        if (requestPassId > 0) {
            axios({ method: 'get', url: URL_API + '/parameters/get-by-key', params: { key: 'SIGNATURE_PDF' } })
            .then((response) => {
                alert.removeAll();
                setSignature(response.data);
            })
            .catch((error) => {
                alert.removeAll();
                alert.error(error.message);
            });
        }
    };
    const apiSaveAgreements = (agreement) => {
        axios({
            method: 'POST',
            url: `${URL_API}/demande-passage/save-agreements`,
            data: agreement,
            params: {
                userAction: user.user_id,
            },
        })
        .then((response) => {
            alert.success('Les accords de principe ont bien été enregistrés !');
        })
        .catch((error) => {
            alert.error(error.message);
        });
    };
    // endregion

    // region Fonctions
    const requestHasPS = () => {
        if (requestPassId > 0) {
            if (demandePassage.metadata.reference.typeDemande === REQUEST_PASS_TYPE.SUPERIEUR) {
                return true;
            }

            let returnState = false;

            demandePassage.metadata.trajetDescr.descr.map((section) => {
                if (section.passType === 'superieur') {
                    returnState = true;
                }
            });

            demandePassage.metadata.trajetDescr.descrRetour.map((section) => {
                if (section.passType === 'superieur') {
                    returnState = true;
                }
            });
            return returnState;
        }

        return false;
    };

    const getElemPatri = () => {
        if (requestPassId > 0) {
            let elemPatris = [];
            demandePassage.metadata.trajetDescr.descr.map((section) => {
                if (demandePassage.metadata.reference.typeDemande === REQUEST_PASS_TYPE.AUTOROUTE && section.passType !== 'superieur') return;
                if (section.elemPatri) {
                    section.elemPatri.map((elemPatri) => {
                        if (elemPatri.status === 'valid') {
                            elemPatris.push(`${elemPatri.id_oa} - ${elemPatri.description ?? '-'} - ${elemPatri.landmark ?? '-'} - ${elemPatri.center ?? '-'} - ${elemPatri.commune ?? '-'}`);
                        }
                    });
                }
            });

            demandePassage.metadata.trajetDescr.descrRetour.map((section) => {
                if (demandePassage.metadata.reference.typeDemande === REQUEST_PASS_TYPE.AUTOROUTE && section.passType !== 'superieur') return;
                if (section.elemPatri) {
                    section.elemPatri.map((elemPatri) => {
                        if (elemPatri.status === 'valid') {
                            elemPatris.push(`${elemPatri.id_oa} - ${elemPatri.description ?? '-'} - ${elemPatri.landmark ?? '-'} - ${elemPatri.center ?? '-'} - ${elemPatri.commune ?? '-'}`);
                        }
                    });
                }
            });

            return elemPatris;
        }
    };

    const convertBlobToBase64 = async (blob) => {
        return await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    };

    const generatePdf = React.useCallback(async () => {
        try {
            const blob = await pdf(<MyDocument />).toBlob();
            setPdfBlob(blob);
        } catch (error) {
            console.error('Error generating PDF:', error);
        }
    }, [fileName]);

    const onSaveAgreementsBtnClick = async () => {
        if (pdfBlob) {
            let base64 = await convertBlobToBase64(pdfBlob);
            let savedAgreement = { ...saveAgreements, data: base64.split(',')[1] };
            apiSaveAgreements(savedAgreement);
        }
    };
    const formatDuration = (durationInMinutes) => {
        let hours = durationInMinutes / 60;
        let minutes = (hours - Math.abs(hours)) * 60;

        return hours + 'h' + minutes;
    };
    const formatPinPoints = () => {
        let pinPoints = '';

        demandePassage.metadata.trajetDescr.descr.map(function(description, index) {
            if (index !== 0) {
                pinPoints += '/';
            }

            if (description.citySectionExit)
                pinPoints += description.nomSection?.toUpperCase() + (description.departmentSectionEnter ? `(${description.departmentSectionEnter})` : '') + '/' + description.citySectionExit?.toUpperCase() + (description.departmentSectionExit ? `(${description.departmentSectionExit})` : '');
            else
                pinPoints += description.nomSection?.toUpperCase() + (description.departmentSectionEnter ? `(${description.departmentSectionEnter})` : '');
        });

        return pinPoints;
    };
    const formatItineraire = () => {
        let itineraire = '';

        demandePassage.metadata.trajetDescr.descr.map(function(description, index) {
            if (index !== 0) {
                itineraire += '/';
            }
            itineraire += (description.descriptionSectionEnter ?? '') + ' ' + (description.descriptionSectionExit ?? '');
        });

        return itineraire;
    };
    const setCategory = () => {
        let category = demandePassage.metadata.caracConvoi.category;
        if (category == 3) {
            return '3ème';
        } else if (category == 2) {
            return '2ème';
        } else {
            return '1ère';
        }
    };

    // endregion

    // region Template

    const stylizeChar = (char) => {
        let style = char.getStyle();
        let convertedStyle = [];
        style.map((style) => {
            switch (style) {
                case 'BOLD':
                    convertedStyle = { ...convertedStyle, fontFamily: 'Helvetica-Bold' };
                    break;
                case 'UNDERLINE':
                    convertedStyle = { ...convertedStyle, textDecoration: 'underline' };
                    break;
                case 'ITALIC':
                    convertedStyle = { ...convertedStyle, fontStyle: 'italic' };
                    break;
                default:
                    convertedStyle = { ...convertedStyle, fontFamily: 'Helvetica' };
                    break;
            }
        });
        return convertedStyle;
    };

    const convertBlockToHtml = (block) => {
        let charList = block.getCharacterList();
        let text = block.getText();
        let html = [];

        // Style is on each char ex : charList[0].getStyle()
        charList.map((char, index) => {
            let charText = text.charAt(index);
            let charStyle = char.getStyle();
            let charHtml = (<Text>{charText}</Text>);

            if (charStyle.size > 0) {
                let convertedStyle = stylizeChar(char);
                charHtml = (<Text style={convertedStyle}>{charText}</Text>);
            }

            html.push(charHtml);
        });

        return html;
    };

    const convertComplementDataToHtmlBlock = (blocks) => {
        if (!blocks || blocks.length === 0) return null;

        // Combine the blocks' text into a single structure for better performance
        return blocks.map((block, index) => {
            // Conditional styles
            let textAlign = block.getData().get('text-align') || 'left';
            let justifyContent = 'flex-start';
            if (textAlign === 'center') {
                justifyContent = 'center';
            } else if (textAlign === 'right') {
                justifyContent = 'flex-end';
            }

            let fontSize = '10px';
            if (block.getType() === 'header-one') {
                fontSize = '18px';
            }

            // Combine block text into a single string
            const blockText = block.getText();

            // Render the block with conditional styles
            return (
                <View key={index} style={{
                    flexDirection: 'row',
                    flexWrap: 'wrap',
                    justifyContent: justifyContent,  // Dynamic justifyContent
                    lineHeight: 1.5,
                    fontSize: fontSize,              // Dynamic fontSize
                    marginTop: block.getText() === '' || block.getText() === '\n' ? '10px' : '0',
                }}>
                    <Text style={{
                        textAlign: textAlign,        // Dynamic textAlign
                        flex: 1,
                        fontFamily: block.getType() === 'header-one' || block.getType() === 'header-four' ? 'Helvetica-Bold' : 'Helvetica',
                        fontWeight: block.getType() === 'header-one' || block.getType() === 'header-four' ? 'bold' : 'normal',
                        textDecoration: block.getType() === 'header-one' ? 'underline' : 'none',
                    }}>
                        {blockText}
                    </Text>
                </View>
            );
        });
    };


    const convertHtmlToDraftJs = (html) => {
        let { contentBlocks, entityMap } = htmlToDraft(html);
        return { contentBlocks, entityMap };
    };

    const formatLegalNotice = React.useMemo(() => {
        if (legalNotice) {
            let render = convertHtmlToDraftJs(legalNotice);
            // Instead of rendering each block individually, combine and render in a single pass
            return convertComplementDataToHtmlBlock(render.contentBlocks);
        }
        return null;
    }, [legalNotice]);

    const formatParticularNotice = React.useMemo(() => {
        if (particularNotice) {
            let render = convertHtmlToDraftJs(particularNotice);
            // Same approach for particular notice
            return convertComplementDataToHtmlBlock(render.contentBlocks);
        }
        return null;
    }, [particularNotice]);


    const Br = () => '\n';

    const departmentNumbers = demandePassage?.metadata.reference.departments.map(department => {
        const match = department.match(/\((\d+)\)/);
        return match ? match[1] : null;
    }).filter(Boolean);

    const agreementPageTemplate = (county) => {
        return (
            <Page size='A4' style={styles.page} dpi={74}>
                {
                    <>
                        <Image
                            src={logoSanef}
                            style={{
                                maxHeight: '80px',
                                maxWidth: '120px',
                                marginLeft: '50px',
                                width: '120px',
                            }}
                            fixed={true}
                        />
                        <View style={styles.sectionHead}>
                            <View style={{
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                margin: '0 150px 0 50px',
                            }}>
                                {demandePassage.metadata.complementIdentite.value === IDENTITY_AGENT_TYPE.POUR_AUTRUI &&
                                    <View style={{
                                        fontSize: '9px',
                                    }}>
                                        <Text>Mandataire :
                                            <Br />{demandePassage.metadata.complementIdentite.mandataire.transporteur}
                                            <Br />{demandePassage.metadata.complementIdentite.mandataire.adresse}
                                            <Br />{demandePassage.metadata.complementIdentite.mandataire.codePostal} {demandePassage.metadata.complementIdentite.mandataire.commune}
                                            <Br />{demandePassage.metadata.complementIdentite.mandataire.pays}
                                        </Text>
                                    </View>
                                }
                                <View style={{
                                    fontSize: '9px',
                                    marginLeft: '80px',
                                }}>
                                    <Text>Pétitionnaire :
                                        <Br />{demandePassage.metadata.complementIdentite.transporteur}
                                        <Br />{demandePassage.metadata.complementIdentite.adresse}
                                        <Br />{demandePassage.metadata.complementIdentite.codePostal} {demandePassage.metadata.complementIdentite.commune}
                                        <Br />{demandePassage.metadata.complementIdentite.pays}
                                    </Text>
                                </View>

                            </View>
                            <View style={{
                                fontSize: '9px',
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                marginLeft: '50px',
                            }}>
                                <View style={{ marginTop: '20px' }}>
                                    <Text style={{ marginTop: '3px' }}>
                                        Numéro de dossier : {demandePassage.id}
                                    </Text>
                                    <Text style={{ marginTop: '3px' }}>
                                        Numéro DDT : {demandePassage.metadata.reference.numDossier}
                                    </Text>
                                    <Text style={{ marginTop: '3px' }}>
                                        Département(s) concerné(s) : {departmentNumbers.join('- ')}
                                    </Text>
                                </View>
                                <View>
                                    <Text
                                        render={() => ('Ormes, le ' + (currentDate.format('DD/MM/YYYY')))}></Text>
                                </View>
                            </View>

                        </View>
                        <View style={{
                            justifyContent: 'center',
                            margin: '-10px auto',
                            fontSize: '14px',
                            fontWeight: 900,
                        }}>
                            <Text>{'ACCORD DE PRINCIPE'}</Text>
                        </View>

                        <View style={{
                            justifyContent: 'center',
                            marginLeft: '50px',
                            marginRight: '50px',
                            marginTop: '15px',
                            fontSize: '10px',
                            color: '#5D6770',
                            fontWeight: 900,
                            border: '2px solid #5D6770',
                            padding: '5px 10px',
                            textAlign: 'center',
                        }}>
                            <Text>{`CE DOCUMENT NE CONSTITUE PAS UNE AUTORISATION DE PASSAGE ET NE PEUT SE SUBSTITUER A L'OBTENTION OBLIGATOIRE DE L'ARRETE DELIVRE PAR LE SERVICE INSTRUCTEUR DE LA SECTION CONCERNEE`}</Text>
                        </View>

                        <View>
                            <View>
                                <Text style={{ fontSize: '9px', marginLeft: '50px' }}>Madame,
                                    Monsieur,</Text>
                            </View>
                            <View>
                                <Text style={{ fontSize: '9px', margin: '0 50px' }}>Je fais suite à votre demande
                                    du {moment(county.receptionDate).format('LL')} et
                                    après examen de votre dossier et acceptation de nos conditions, je vous confirme mon
                                    accord de
                                    principe pour :</Text>
                            </View>
                        </View>

                        <View style={{ ...styles.sectionBody, height: 'auto', margin: 0 }}>
                            <View style={{ height: 'auto' }} wrap>
                                <View style={{ marginLeft: '50px', marginRight: '50px' }}>
                                    <View style={{ fontSize: '9px' }}>

                                        <View
                                            style={{ ...styles.caracRow, borderRight: 1, borderLeft: 1, borderTop: 1 }}>
                                            <Text style={{ width: '30%', borderRight: 1, padding: 3 }}>Nombre de
                                                passages:</Text>
                                            <Text style={{ textAlign: 'left', padding: 3, width: '70%' }}
                                                  render={() => (`${county.nbPassages.nbPass} passages (${county.nbPassages.nbFare} allers et ${county.nbPassages.nbReturn} retours)`)}></Text>
                                        </View>

                                        <View
                                            style={{ ...styles.caracRow, borderRight: 1, borderLeft: 1, borderTop: 1 }}>
                                            <Text style={{ width: '30%', borderRight: 1, padding: 3 }}>Nombre de
                                                convois:</Text>
                                            <Text style={{ textAlign: 'left', padding: 3, width: '70%' }}
                                                  render={() => `${demandePassage.metadata.datePassage.nbVehiculeAller + demandePassage.metadata.datePassage.nbVehiculeRetour} convoi(s) (${demandePassage.metadata.datePassage.nbVehiculeAller} aller(s) ${(demandePassage.metadata.datePassage.nbPassageRetour !== 0 || demandePassage.metadata.datePassage.nbVehiculeRetour !== 0) ? ' et ' + demandePassage.metadata.datePassage.nbVehiculeRetour + ' retour(s)' : ''})`}>
                                            </Text>
                                        </View>

                                        <View
                                            style={{ ...styles.caracRow, borderRight: 1, borderLeft: 1, borderTop: 1 }}>
                                            <Text style={{ width: '30%', borderRight: 1, padding: 3 }}>Catégorie:</Text>
                                            <Text style={{
                                                textAlign: 'left',
                                                padding: 3,
                                                width: '70%',
                                            }}>{county.category ?? '-'}</Text>
                                        </View>

                                        {/* TODO : demandePassage.metadata.complInfo.startDate + demandePassage.metadata.complInfo.endDate */}
                                        <View
                                            style={{ ...styles.caracRow, borderRight: 1, borderLeft: 1, borderTop: 1 }}>
                                            <Text style={{ width: '30%', borderRight: 1, padding: 3 }}>Horaires de
                                                passage:</Text>
                                            <Text style={{ textAlign: 'left', padding: 3, width: '70%' }}
                                                  render={() => (
                                                      demandePassage.metadata.complInfo.horPassDebut
                                                          ? `${moment(demandePassage.metadata.complInfo.horPassDebut).format('HH:mm')} - ${moment(demandePassage.metadata.complInfo.horPassFin).format('HH:mm')}`
                                                          : '-'
                                                  )}></Text>
                                        </View>

                                        <View
                                            style={{ ...styles.caracRow, borderRight: 1, borderLeft: 1, borderTop: 1 }}>
                                            <Text style={{ width: '30%', borderRight: 1, padding: 3 }}>Durée de
                                                validité:</Text>
                                            <Text style={{ textAlign: 'left', padding: 3, width: '70%' }}
                                                  render={() => (`${county.duration} mois à compter de la date de début de validité de l'arrêté`)}></Text>
                                        </View>

                                        <View
                                            style={{ ...styles.caracRow, borderRight: 1, borderLeft: 1, borderTop: 1 }}>
                                            <Text style={{ width: '30%', borderRight: 1, padding: 3 }}>Liaison:</Text>
                                            <Text style={{
                                                textAlign: 'left',
                                                padding: 3,
                                                width: '70%',
                                            }}>{demandePassage.metadata.trajetDescr.depart} - {demandePassage.metadata.trajetDescr.arrivee}</Text>
                                        </View>

                                        <View
                                            style={{ ...styles.caracRow, borderRight: 1, borderLeft: 1, borderTop: 1 }}>
                                            <Text style={{ width: '30%', borderRight: 1, padding: 3 }}>Itinéraire sur
                                                autoroute:</Text>
                                            <Text style={{ textAlign: 'left', padding: 3, width: '70%' }}>
                                                {
                                                    demandePassage.metadata.trajetDescr.descr.map((section) => {
                                                        if (section.passType === 'superieur' || !section.nomSection || section.nomSection === '') {
                                                            // Uniquement pour autoroute
                                                            return null;
                                                        }
                                                        return section.nomSection;
                                                    }).filter(Boolean).join(' / ')
                                                }
                                                <span>  -   </span>
                                                {
                                                    demandePassage.metadata.trajetDescr.descrRetour.map((section) => {
                                                        if (section.passType === 'superieur' || !section.nomSection || section.nomSection === '') {
                                                            // Uniquement pour autoroute
                                                            return null;
                                                        }
                                                        return section.nomSection;
                                                    }).filter(Boolean).join(' / ')
                                                }
                                            </Text>
                                        </View>

                                        <View
                                            style={{ ...styles.caracRow, borderRight: 1, borderLeft: 1, borderTop: 1 }}>
                                            <Text style={{ width: '30%', borderRight: 1, padding: 3 }}>Nature du
                                                chargement:</Text>
                                            <Text style={{
                                                textAlign: 'left',
                                                padding: 3,
                                                width: '70%',
                                            }}>{county.natureCharge ?? '-'}</Text>
                                        </View>

                                        <View
                                            style={{ ...styles.caracRow, borderRight: 1, borderLeft: 1, borderTop: 1 }}>
                                            <Text style={{ width: '30%', padding: 3 }}>Caractéristiques
                                                maximales:</Text>
                                        </View>

                                        <View
                                            style={{ ...styles.caracRow, borderRight: 1, borderLeft: 1, borderTop: 1 }}>
                                            <Text style={{ width: '30%', borderRight: 1, padding: 3 }}>Longueur:</Text>
                                            <Text style={{
                                                textAlign: 'left',
                                                padding: 3,
                                                width: '70%',
                                            }}>{county.longueurCharge ?? '-'} m</Text>
                                        </View>

                                        <View
                                            style={{ ...styles.caracRow, borderRight: 1, borderLeft: 1, borderTop: 1 }}>
                                            <Text style={{ width: '30%', borderRight: 1, padding: 3 }}>Largeur:</Text>
                                            <Text style={{
                                                textAlign: 'left',
                                                padding: 3,
                                                width: '70%',
                                            }}>{county.largeurCharge ?? '-'} m</Text>
                                        </View>

                                        <View
                                            style={{ ...styles.caracRow, borderRight: 1, borderLeft: 1, borderTop: 1 }}>
                                            <Text style={{ width: '30%', borderRight: 1, padding: 3 }}>Hauteur:</Text>
                                            <Text style={{
                                                textAlign: 'left',
                                                padding: 3,
                                                width: '70%',
                                            }}>{county.hauteurCharge ?? '-'} m</Text>
                                        </View>

                                        <View
                                            style={{ ...styles.caracRow, borderRight: 1, borderLeft: 1, borderTop: 1 }}>
                                            <Text style={{ width: '30%', borderRight: 1, padding: 3 }}>Poids total en
                                                charge maxi: </Text>
                                            <Text style={{
                                                textAlign: 'left',
                                                padding: 3,
                                                width: '70%',
                                            }}>{parseFloat((Number(county.maxWeight) / 1000).toString()).toFixed(3)} T</Text>
                                        </View>

                                        {demandePassage.metadata.caracConvoi.configurations.length === 0 &&
                                            <View style={{
                                                ...styles.caracRow,
                                                borderRight: 1,
                                                borderLeft: 1,
                                                borderTop: 1,
                                                borderBottom: 1,
                                            }}>
                                                <Text style={{ width: '30%', borderRight: 1, padding: 3 }}>Charge maxi
                                                    par essieu:</Text>
                                                <Text style={{
                                                    textAlign: 'left',
                                                    padding: 3,
                                                    width: '70%',
                                                }}>{'<13 T.'}</Text>
                                            </View>
                                        }

                                        {demandePassage.metadata.caracConvoi.configurations.length > 0 &&
                                            <>
                                                <View style={{
                                                    ...styles.caracRow,
                                                    borderRight: 1,
                                                    borderLeft: 1,
                                                    borderTop: 1,
                                                }}>
                                                    <Text style={{ width: '30%', padding: 3 }}>Configurations :</Text>
                                                    <Text style={{ textAlign: 'left', padding: 3, width: '35%' }}>Charge
                                                        maxi par essieu</Text>
                                                    <Text style={{ textAlign: 'left', padding: 3, width: '35%' }}>Distance
                                                        mini entre essieux</Text>
                                                </View>

                                                {demandePassage.metadata.caracConvoi.configurations.map((config, index, array) => (
                                                    <View style={{
                                                        ...styles.caracRow,
                                                        borderRight: 1,
                                                        borderLeft: 1,
                                                        borderTop: 1,
                                                        borderBottom: (!(requestHasPS() && getElemPatri().length > 0) && index === array.length - 1) ? 1 : 0,
                                                    }}>
                                                        <Text style={{
                                                            width: '30%',
                                                            borderRight: 1,
                                                            padding: 3,
                                                        }}>N° {config.index}</Text>
                                                        <Text style={{
                                                            textAlign: 'left',
                                                            padding: 3,
                                                            width: '35%',
                                                        }}>{parseFloat((Number(config.chargeMaxiEssieu) / 1000).toString()).toFixed(3)} T</Text>
                                                        <Text style={{
                                                            textAlign: 'left',
                                                            padding: 3,
                                                            width: '35%',
                                                        }}>{parseFloat((Number(config.distanceMiniInterEssieu) / 1000).toString()).toFixed(2)} m</Text>
                                                    </View>
                                                ))}
                                            </>
                                        }

                                        {(requestHasPS() && getElemPatri().length > 0) &&
                                            <>
                                                <View style={{
                                                    ...styles.caracRow,
                                                    borderRight: 1,
                                                    borderLeft: 1,
                                                    borderTop: 1,
                                                    borderBottom: 1,
                                                }}>
                                                    <Text style={{ width: '30%', borderRight: 1, padding: 3 }}>Elements
                                                        Patrimoine traversés en PS</Text>
                                                    <Text style={{ textAlign: 'left', padding: 3, width: '70%' }}>
                                                        {getElemPatri().map((elemPatri, index) => (
                                                            <React.Fragment key={index}>
                                                                {elemPatri}
                                                                <Br />
                                                            </React.Fragment>
                                                        ))}
                                                    </Text>
                                                </View>
                                            </>
                                        }

                                    </View>
                                </View>

                                <View style={{ display: 'flex', margin: '5px auto', padding: '0 50px' }}>
                                    <Text style={{ fontSize: '9px', fontWeight: 800, textAlign: 'center' }}>
                                        {('L\'emprunt des autoroutes concédées est soumis aux prescriptions générales et particulières indiquées à la suite de ce document.').toUpperCase()}
                                    </Text>
                                </View>
                            </View>
                        </View>

                        <View style={{ position: 'relative', marginBottom: '50px', marginTop: '20px' }}>
                            <View style={{ marginLeft: '50px', marginRight: '50px', fontSize: '9px' }}>
                                <View style={{ marginBottom: '10px' }}>
                                    <Text style={{ fontSize: '9px', textDecoration: 'underline' }}>
                                        Mesures d'exploitation :
                                    </Text>

                                    <View>
                                        <Text style={{ fontSize: '9px', margin: '2px 0', fontWeight: 'bold' }}>
                                            {demandePassage.metadata.caracConvoi.accompagnement ? 'Accompagnement Sanef préconisé sur l\'ensemble de l\'itinéraire décrit ci-dessus. ' : ''}
                                        </Text>
                                    </View>

                                    {devis && devis.elements_factures.lines.map((line) => {
                                        if (line.mesures_exploit)
                                            return <View style={{ flexDirection: 'row', marginBottom: '10px' }}>
                                                <Text style={{ fontSize: '9px' }}>{line.libelle} :</Text>
                                                <Text style={{ marginLeft: '10px' }}>{line.mesures_exploit}</Text>
                                            </View>;
                                    })}

                                    <Text style={{
                                        marginLeft: '10px',
                                        marginBottom: '5px',
                                    }}>{demandePassage.metadata.complInfo.servTeInfo ?? '-'}</Text>
                                </View>

                            </View>

                            <View style={{ marginLeft: '50px', marginRight: '50px', fontSize: '9px' }}>
                                <View style={{ flexDirection: 'column', marginBottom: '10px' }}>
                                    {demandePassage.metadata.complInfo.servOaInfo &&
                                        <>
                                            <Text style={{ fontSize: '9px', textDecoration: 'underline' }}>Service
                                                Ouvrage d'Art
                                                :</Text>
                                            <Text style={{
                                                marginLeft: '10px',
                                                marginTop: '10px',
                                                marginBottom: '10px',
                                            }}>{demandePassage.metadata.complInfo.servOaInfo ?? '-'}</Text>
                                        </>
                                    }
                                    <Text
                                        style={{ fontSize: '9px', textDecoration: 'underline', marginBottom: '10px' }}>Centre(s)
                                        :</Text>
                                    {demandePassage.metadata.complInfo.refCtr.map((ctr) => {
                                        if (!ctr.comment || ctr.comment === '') return;
                                        return (<View
                                            style={{ flexDirection: 'column', marginBottom: '10px', width: '90%' }}>
                                            <Text style={{ fontSize: '9px' }}>{ctr.name} :</Text>
                                            <Text style={{ marginLeft: '15px' }}>{ctr.comment ?? '-'}</Text>
                                        </View>);
                                    })
                                    }
                                </View>

                                {/*<View style={{ flexDirection: 'row', marginBottom: '10px' }}>*/}
                                {/*  <Text style={{ fontSize: '11px' }}>SERVICE TE :</Text>*/}
                                {/*  <Text style={{ marginLeft: '10px' }}>{demandePassage.metadata.complInfo.servTeInfo}</Text>*/}
                                {/*</View>*/}
                            </View>

                            <View>
                                <View style={{ marginLeft: '50px', marginRight: '50px' }}>
                                    <Text style={{ fontSize: '9px', fontWeight: 'bold' }}>Pour l'organisation des
                                        accompagnements
                                        et l'obtention des autorisations de passage, prendre contact avec le service des
                                        convois
                                        exceptionnels au minimum 72h avant la date.</Text>
                                    <Text style={{ fontSize: '9px', marginTop: 5 }}>
                                        Je vous prie d'agréer, Madame, Monsieur, l'expression de mes salutations
                                        distinguées.
                                    </Text>
                                    <>
                                        {signature && <Image src={signature} style={{
                                            maxHeight: '50px',
                                            maxWidth: '150px',
                                            marginTop: 10,
                                            marginLeft: 'auto',
                                            width: '150px',
                                        }} />}
                                    </>
                                </View>
                            </View>
                        </View>

                        <View style={{
                            display: 'flex',
                            flexDirection: 'column',
                            fontSize: '10px',
                            margin: '20px 40px',
                            justifyContent: 'center',
                        }} break={true}>
                            {legalNotice && formatLegalNotice}
                        </View>

                        <View style={{
                            display: 'flex',
                            flexDirection: 'column',
                            fontSize: '10px',
                            margin: '20px 40px',
                            justifyContent: 'center',
                        }} break={true}>
                            {particularNotice && formatParticularNotice}
                        </View>
                    </>
                }
                <View fixed={true}
                      style={{ position: 'absolute', fontSize: 5, bottom: 15, left: 0, right: 0, textAlign: 'center' }}>
                    <Text>
                        Site de l'Ecopôle - Route de Thillois - Ormes
                        <Br />
                        CS 30011 51886 REIMS Cedex
                        <Br />
                        S.A. au capital de 53 090 461,67 euros - RCS Nanterre B632 050 019
                    </Text>
                </View>
            </Page>
        );
    };

    const MyDocument = React.memo(() => {
        return (
            <PdfGenerator
                title={`Accords de principe demande n° [${requestPassId}]`}
                template={counties.map((county) => agreementPageTemplate(county))}
            />
        );
    }, [legalNotice, particularNotice, counties]);

    useEffect(() => {
        if (!pdfBlob && fileName) {
            generatePdf();
        }
    }, [fileName]);

    //#endregion

    return (
        <div style={{ height: '100%', width: '100%' }}>
            <TopBar title={'Accords de principe demande n° [' + requestPassId + ']'} className='topbar-contenu'
                    color={props.params.color}
                    buttons={
                        <div className='topbar-buttons'>
                            <MyButton label='Retour' icon={faArrowLeft} onClick={() => {
                                navigate('/demande-passage');
                            }} />

                            {fileName && pdfBlob && (
                                <PDFDownloadLink
                                    document={<MyDocument />}
                                    fileName={fileName + '.pdf'}
                                    blob={pdfBlob}
                                >
                                    {({ loading }) => (
                                        loading ? (
                                            <MyButton label='Génération...' icon={faFilePdf} disabled={true} />
                                        ) : (
                                            <>
                                                <MyButton label='Sauvegarder et notifier le client' icon={faSave}
                                                          onClick={onSaveAgreementsBtnClick} />
                                                <MyButton label='Télécharger' icon={faFilePdf} />
                                            </>
                                        )
                                    )}
                                </PDFDownloadLink>
                            )}
                        </div>
                    }
            />
            {pdfBlob ? (
                <PDFViewer style={{ height: '94%', width: '100%' }} showToolbar={false}>
                    <MyDocument />
                </PDFViewer>
            ) : (
                <p>Chargement...</p>
            )}
        </div>
    );
};

export default AgreementsViewer;